import NewsletterContainer from './NewsletterContainer';

export default NewsletterContainer;
